module.exports = __webpack_public_path__ + "static/media/room-feature-area.f70d9e56.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/room-feature-area.svg
// module id = 562
// module chunks = 9